import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'vr-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent {

  isOpen: boolean;

  @ViewChild('input') input: ElementRef;

  constructor() { }

  open() {
    this.isOpen = true;

    setTimeout(() => {
      this.input.nativeElement.focus();
    }, 100);

  }

  close() {}

}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/toolbar/search/search.component.ts